var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"content-breadcrumb"}},[_c('b-breadcrumb',_vm._l((_vm.bItems),function(item,index){return _c('b-breadcrumb-item',{key:index,attrs:{"to":item.to,"title":item.text,"active":index === _vm.bItems.length-1}},[_vm._v("\n      "+_vm._s(item.text)+"\n    ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }